import { Prismic, parseTariff, isEmptyText } from '@landsbankinn/prismic';
import { Segment, TrailRow } from '@landsbankinn/ui';
import React from 'react';
import { PointCard } from '../components/card/PointCard';

interface IProps {
  size: 'Large' | 'Extra Large';
  color: string;
  fields: IField[];
}

interface IField {
  title: Prismic.RichText;
  copy: Prismic.RichText;
  prefix: Prismic.RichText;
  number: Prismic.RichText;
  suffix: Prismic.RichText;
  cols?: number;
  pointColor?: string;
  isLarge?: boolean;
  isNumberRightAligned?: boolean;
}

const CardItem = ({
  title,
  copy,
  number,
  suffix,
  prefix,
  cols,
  pointColor,
  isLarge,
  isNumberRightAligned,
  ...rest
}: IField) => {
  return (
    <PointCard
      label={Prismic.text(title) ?? undefined}
      copy={Prismic.text(copy)}
      numberText={parseTariff(Prismic.text(number))}
      prefix={Prismic.text(prefix)}
      suffix={Prismic.text(suffix)}
      isSplitterLong={true}
      cols={cols}
      pointColor={pointColor}
      pointsType="Text"
      isBottomAligned={false}
      isNumberTextLarge={isLarge}
      isNumberRightAligned={isNumberRightAligned}
      {...rest}
    />
  );
};

export const HighlightNumbersContainer = ({ size, color, fields }: IProps) => {
  const pointsCount = fields?.length;
  const hasFirstCopy = !isEmptyText(fields[0].copy);

  return (
    <Segment>
      <TrailRow>
        {fields?.map((item, index) => {
          return (
            <CardItem
              key={`${index}-${Prismic.text(item.copy)}`}
              cols={12 / pointsCount}
              pointColor={color}
              isLarge={size === 'Large'}
              isNumberRightAligned={hasFirstCopy}
              {...item}
            />
          );
        })}
      </TrailRow>
    </Segment>
  );
};
